module.exports = __webpack_public_path__ + "img/sankaku_33_red.f3cb49a3.png";